<template>
  <b-row class="flow-chart">
    <b-col>
      <flowy :nodes="nodes" class="justify-content-center" @click="$emit('click', 'values')" />
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: "DashboardFlowChart",
  props: {
    nodes: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
  .flow-chart {
    .flowy {
      overflow: hidden !important;
      .flowy-tree {
        .arrowblock, .arrowblock-down {
          svg {
            filter: brightness(0) saturate(100%) invert(100%) sepia(5%) saturate(81%) hue-rotate(325deg) brightness(111%) contrast(87%);
          }
        }
        .circle-container {
          margin: 0 auto;
        }
        .flowy-node {
          margin: auto;
          min-width: 25%;
          .flowy-block {
            margin: 0 !important;
            .node-dropzone {
              display: none;
            }
          }
          .hidden {
            display: none;
            & ~ .arrowblock {
              display: none;
            }
          }
          .stat-box {
            margin-top: 10px !important;
            width: 100%;
            max-width: 130px;
            margin: 0 0px;
            > div {
              padding: 0;
            }
          }
        }

        .flowy-tree {
          .flowy-node {
            margin: 0;
            width: 100%;
            .flowy-block {
              width: 100%;
            }
          }
          .flowy-tree {
            width: 100%;
            padding: 0 0.1em;
            margin-top: 20px;
            .arrowblock {
              margin-top: 30px;
              height: 20px;
              overflow: hidden;
            }
            .flowy-tree {
              padding: 0;
              margin-top: 0px;
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: 960px) and (max-width: 1199px ) {
    .flow-chart {
      .flowy {
        .flowy-tree {
          .circle-container {
            width: 4.3em;
            height: 4.3em;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1200px) and (max-width: 1399px ) {
    .flow-chart {
      .flowy {
        .flowy-tree {
          .circle-container {
            width: 5em;
            height: 5em;
          }
        }
      }
    }
  }


  @media screen and (min-width: 1800px) {
    .flow-chart {
      .flowy {
        .flowy-tree {
          .flowy-node {
            min-width: 130px;
            .stat-box {
              width: 130px;
            }
          }
        }
      }
    }
  }
</style>

<style>
.hidden ~ .arrowblock {
    display: none;
}
</style>
